import { infoCircleIcon } from "../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `TitleWidget` is used to render the page title, subtitle and the help.
 *
 * It builds a hidden modal window, so it requires a special disposal hook
 * to clean up the DOM.
 *
 * @param {Renderable} title - 2 to 3 words describing the page.
 * @param {Renderable} [subtitle] - A few more words describing the page. Will be displayed in a smaller font than the title.
 * @param {HelpWizard} [helpWizard] - Wizard used to guide the user
 * through the feature of the current document. Required if `helpEnabled` is true.
 * @param {boolean} [helpEnabled] - When true, display a button to start the help wizard.
 * @param {Renderable} [id] - CSS id of the main DIV element.
 * @param {Renderable} [titleBuilder] - Object to which the receiver will ask for the title and subtitle.
 * @example
 * titleWidget({
 *     title: 'Page Title',
 *     subtitle: 'Page subtitle'
 * })
 */
export default class TitleWidget2 extends Widget {
	constructor({
		title,
		subtitle = "",
		helpWizard,
		helpEnabled,
		id = "document-title",
		titleBuilder,
	}) {
		super(...arguments);
		this._title = title;
		this._subtitle = subtitle;
		this._titleId = id;
		this._helpWizard = helpWizard;
		this._helpEnabled = helpEnabled;
		this._titleBuilder = titleBuilder;
	}

	updateTitleAndSubtitle() {
		if (!this._titleBuilder) {
			this.update();
			return;
		}

		const newTitle = this._titleBuilder.getTitle();
		const newSubtitle = this._titleBuilder.getSubtitle();
		this._title = newTitle;
		this._subtitle = newSubtitle;
		this.update();
	}

	subtitle() {}

	renderContentOn(html) {
		html.div(
			{ id: this._titleId },
			html.h1(
				{
					"data-test": "document-title",
					"data-help": "document-title",
				},
				this._title,
				this._renderHelpToggleOn.bind(this),
			),
			html.p(
				{
					class: "subtitle",
					"data-test": "document-subtitle",
					"data-help": "document-subtitle",
				},
				this._subtitle,
			),
		);
	}

	_renderHelpToggleOn(html) {
		if (!this._helpEnabled) {
			return;
		}

		html.div(
			{ id: "info-toggler" },
			html.a(
				{
					"data-toggle": "modal",
					"data-test": "help",
					click: this._startHelp.bind(this),
				},
				infoCircleIcon,
			),
		);
	}

	_startHelp() {
		this._helpWizard.start();
	}
}
